import CancellableHelper from "@/requests/CancellableHelper";
import { OfficeFormOfPayment } from "@/models/api/administration/offices/OfficeFormOfPayment";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";
import { OfficeProfileFormOfPayment } from "@/models/api/administration/offices/OfficeProfileFormOfPayment";
import { OfficeFormOfPaymentByType } from "@/models/api/administration/offices/OfficeFormOfPaymentByType";
import { FORM_OF_PAYMENT_TYPE } from "@/static/formOfPaymentType";

export const URL_GET_FORM_OF_PAYMENTS_OFFICE_PROFILE_ID = "/Office/FormOfPaymentsByOfficeProfileId";
export const URL_POST_ASSIGN_PAYMENT_TO_OFFICE_PROFILE = "/Office/AssignPaymentMethodToOfficeProfile";
export const URL_POST_UNASSIGN_PAYMENT_TO_OFFICE_PROFILE = "/Office/UnassignPaymentMethodToOfficeProfile";
export const URL_POST_SET_CAN_ISSUE_RECEIPT = "/Office/SetValueCanIssueReceipt";
export const URL_POST_SET_CAN_ISSUE_RECEIPT_INDIVIDUAL = "/Office/SetValueCanIssueReceiptIndividualContractor";
export const URL_GET_FORM_OF_PAYMENTS_ALL = "/Office/FormOfPayments/All";
export const URL_POST_FORM_OF_PAYMENT_TYPE_UPDATE = "/Office/FormOfPaymentType/Update";
export const URL_GET_FORM_OF_PAYMENTS_BY_TYPE = "/Office/FormOfPayments/${FormOfPaymentId}/Types";

const _getFormofPaymentByOfficeProfileId = new CancellableHelper<Array<OfficeFormOfPayment>>(
  URL_GET_FORM_OF_PAYMENTS_OFFICE_PROFILE_ID,
  OfficeFormOfPayment
);
export const getFormOfPaymentByOfficeProfileId = async (
  officeProfileId: number
): Promise<Array<OfficeFormOfPayment>> => {
  return _getFormofPaymentByOfficeProfileId.get({
    OfficeProfileId: officeProfileId,
  });
};

const _postAssignPaymentMethodToOfficeProfile = new CancellableHelper<null>(URL_POST_ASSIGN_PAYMENT_TO_OFFICE_PROFILE);
export const assignFormOfPaymentToOfficeProfile = async (
  officeProfileId: number,
  paymentMethodId: number
): Promise<null> => {
  return _postAssignPaymentMethodToOfficeProfile.post({
    OfficeProfileId: officeProfileId,
    PaymentMethodId: paymentMethodId,
  });
};

const _postUnassignPaymentMethodToOfficeProfile = new CancellableHelper<null>(
  URL_POST_UNASSIGN_PAYMENT_TO_OFFICE_PROFILE
);
export const unassignFormOfPaymentToOfficeProfile = async (
  officeProfileId: number,
  paymentMethodId: number
): Promise<null> => {
  return _postUnassignPaymentMethodToOfficeProfile.post({
    OfficeProfileId: officeProfileId,
    PaymentMethodId: paymentMethodId,
  });
};

const _postSetValueCanIssueReceipt = new CancellableHelper<null>(URL_POST_SET_CAN_ISSUE_RECEIPT);
export const setValueCanIssueReceipt = async (formOfPayment: FORM_OF_PAYMENTS, value: boolean): Promise<null> => {
  return _postSetValueCanIssueReceipt.post({
    FormOfPayment: formOfPayment,
    Value: value,
  });
};

const _postSetValueCanIssueReceiptIndividualContractor = new CancellableHelper<null>(
  URL_POST_SET_CAN_ISSUE_RECEIPT_INDIVIDUAL
);
export const setValueCanIssueReceiptIndividualContractor = async (
  formOfPayment: FORM_OF_PAYMENTS,
  value: boolean
): Promise<null> => {
  return _postSetValueCanIssueReceiptIndividualContractor.post({
    FormOfPayment: formOfPayment,
    Value: value,
  });
};

const _getFormofPaymentsAll = new CancellableHelper<Array<OfficeProfileFormOfPayment>>(
  URL_GET_FORM_OF_PAYMENTS_ALL,
  OfficeProfileFormOfPayment
);
export const getFormOfPaymentsAll = async (): Promise<Array<OfficeProfileFormOfPayment>> => {
  return _getFormofPaymentsAll.get();
};

const _postFormOfPaymentTypeUpdate = new CancellableHelper<null>(URL_POST_FORM_OF_PAYMENT_TYPE_UPDATE);
export const postFormOfPaymentTypeUpdate = async (
  formOfPayment: FORM_OF_PAYMENTS,
  formOfPaymentType: FORM_OF_PAYMENT_TYPE,
  formOfPaymentTypeIsAssigned: boolean
): Promise<null> => {
  return _postFormOfPaymentTypeUpdate.post({
    FormOfPayment: formOfPayment,
    FormOfPaymentType: formOfPaymentType,
    FormOfPaymentTypeIsAssigned: formOfPaymentTypeIsAssigned,
  });
};

const _getFormOfPaymentsByType = new CancellableHelper<Array<OfficeFormOfPaymentByType>>(
  URL_GET_FORM_OF_PAYMENTS_BY_TYPE,
  OfficeFormOfPaymentByType
);
export const getFormOfPaymentsByType = async (id: number): Promise<Array<OfficeFormOfPaymentByType>> => {
  return _getFormOfPaymentsByType.get({ FormOfPaymentId: id });
};
